import React, { useState, useEffect } from 'react';

export default function CardsComingSoonV2({ userDetails }) {
  const [buttonClicked, setButtonClicked] = useState(false);

  // Récupérer l'email de l'utilisateur connecté
  const userEmail = userDetails?.email || '';

  // Charger l'état au montage du composant
  useEffect(() => {
    if (userEmail) {
      const waitlistStatus = localStorage.getItem(`waitlist_${userEmail}`);
      if (waitlistStatus === 'true') {
        setButtonClicked(true);
      }
    }
  }, [userEmail]);

  const handleButtonClick = () => {
    setButtonClicked(true);
    // Sauvegarder pour cet utilisateur spécifique
    if (userEmail) {
      localStorage.setItem(`waitlist_${userEmail}`, 'true');
    }
  };

  return (
    <div className="fixed inset-0 min-h-screen bg-gradient-to-br from-violet-950 via-violet-900 to-black flex flex-col items-center justify-between p-4 pb-24 overflow-hidden">
      {/* Éléments décoratifs de fond */}
      <div className="absolute top-[-100px] right-[-50px] w-96 h-96 bg-violet-600/30 rounded-full blur-[120px]"></div>
      <div className="absolute bottom-[-80px] left-[-80px] w-[500px] h-[500px] bg-purple-700/20 rounded-full blur-[100px]"></div>
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-pink-600/10 rounded-full blur-[80px]"></div>
      
      {/* Contenu principal */}
      <div className="flex-1 flex flex-col items-center justify-center w-full max-w-md relative z-10 pt-20">
        
        {/* Cards flottantes */}
        <div className="relative w-full mb-6">
          
          {/* Card 1 - Hust Balance */}
          <div 
            className="absolute top-4 left-4 w-40 h-20 bg-white/5 backdrop-blur-2xl rounded-2xl border border-white/10 shadow-[0_8px_32px_rgba(139,92,246,0.15)] transform rotate-[-12deg] flex items-center gap-2 p-3 hover:scale-105 transition-transform duration-300"
            style={{ animation: 'floatCash 4s ease-in-out infinite' }}
          >
            <div className="w-8 h-8 bg-gradient-to-br from-violet-500/30 to-purple-600/30 rounded-xl flex items-center justify-center backdrop-blur-sm">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                <circle cx="12" cy="7" r="4"/>
              </svg>
            </div>
            <div>
              <p className="text-white/50 text-[9px] font-medium">Hust Balance</p>
              <p className="text-white text-base font-bold tracking-tight">€18,207</p>
            </div>
          </div>
          
          {/* Card 2 - CARTE BANCAIRE */}
          <div 
            className="absolute top-28 left-1/2 transform -translate-x-1/2 w-64 h-40 rounded-2xl p-4 flex flex-col justify-between hover:scale-105 transition-transform duration-300"
            style={{
              background: 'linear-gradient(135deg, rgba(139, 92, 246, 1) 0%, rgba(168, 85, 247, 0.95) 100%)',
              boxShadow: '0 25px 50px -12px rgba(139, 92, 246, 0.5)'
            }}
          >
            <div className="flex justify-end items-start">
              <span className="text-white text-xl font-black">HUST</span>
            </div>
            
            <div></div>
            
            <div className="flex justify-between items-end">
              <div>
                <p className="text-white/90 text-sm font-medium tracking-wider">•••• 6115</p>
              </div>
              <div className="flex flex-col items-end gap-1">
                <span className="text-white/90 text-xs font-medium">debit</span>
                <div className="flex items-center">
                  <div className="w-6 h-6 rounded-full bg-red-500"></div>
                  <div className="w-6 h-6 rounded-full bg-orange-400 -ml-2"></div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Pièce HUST 3D - DESCENDUE */}
          <div 
            className="absolute top-60 w-28 h-28 transform rotate-[25deg] hover:rotate-[35deg] transition-all duration-500"
            style={{
              perspective: '1000px',
              transformStyle: 'preserve-3d',
              right: '8px'
            }}
          >
            <div 
              className="relative w-full h-full"
              style={{
                transform: 'rotateY(-30deg) rotateX(15deg)',
                transformStyle: 'preserve-3d',
                animation: 'floatCoin 3s ease-in-out infinite'
              }}
            >
              <div className="absolute inset-0 bg-violet-900/40 rounded-full blur-2xl transform translate-y-4 scale-110"></div>
              
              <div 
                className="relative w-full h-full rounded-full bg-gradient-to-br from-lime-300 via-yellow-300 to-lime-400 flex items-center justify-center"
                style={{
                  boxShadow: '0 25px 50px rgba(163, 230, 53, 0.5), inset 0 2px 10px rgba(255, 255, 255, 0.6), inset 0 -2px 10px rgba(0, 0, 0, 0.2)'
                }}
              >
                <span 
                  className="text-violet-900 text-6xl font-black drop-shadow-lg"
                  style={{
                    textShadow: '3px 3px 6px rgba(0,0,0,0.3)',
                    display: 'inline-block'
                  }}
                >
                  H
                </span>
                
                <div className="absolute top-2 left-4 w-14 h-6 bg-white/40 rounded-full blur-xl transform -rotate-45"></div>
              </div>
              
              <div 
                className="absolute inset-0 rounded-full"
                style={{
                  background: 'linear-gradient(90deg, rgba(163, 230, 53, 0.8) 0%, rgba(163, 230, 53, 0.4) 50%, rgba(163, 230, 53, 0.8) 100%)',
                  transform: 'translateZ(-8px)',
                  boxShadow: '0 0 20px rgba(163, 230, 53, 0.3)'
                }}
              ></div>
            </div>
          </div>
          
        </div>
        
        <div className="h-72"></div>
        
        {/* Titres - LÉGÈREMENT DESCENDUS */}
        <div className="w-full max-w-md text-center mb-4 px-2 mt-8">
          <h1 
            className="text-xl font-bold text-white mb-2 leading-none" 
            style={{
              background: 'linear-gradient(180deg, #ffffff 0%, #e9d5ff 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              letterSpacing: '-0.01em'
            }}
          >
            Cartes HUST
          </h1>
          <h2 
            className="text-4xl font-black text-violet-200/90"
            style={{
              letterSpacing: '-0.03em',
              textShadow: '0 0 80px rgba(139, 92, 246, 0.3)',
              lineHeight: '1.1'
            }}
          >
            Bientôt Disponible
          </h2>
        </div>
        
        {/* Texte descriptif */}
        <div className="text-white/90 text-center px-4 mb-6 max-w-sm">
          <p className="text-base font-semibold mb-2 text-violet-200">Réservé aux membres actifs.</p>
          <p className="text-sm leading-relaxed mb-3 text-white/70">Carte virtuelle en accès anticipé.</p>
          
          <div className="text-left space-y-2 bg-white/5 backdrop-blur-sm rounded-xl p-3 border border-white/10">
            <div className="flex items-center gap-2">
              <span className="text-lime-400 font-black text-base">1.</span>
              <p className="text-white/90 text-xs font-medium">Importez votre portefeuille crypto</p>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-lime-400 font-black text-base">2.</span>
              <p className="text-white/90 text-xs font-medium">Rejoignez la liste d'attente prioritaire</p>
            </div>
          </div>
        </div>
        
      </div>
      
      {/* Bouton CTA */}
      <div className="w-full max-w-md pb-4 relative z-10 px-2">
        <button 
          onClick={handleButtonClick}
          disabled={buttonClicked}
          className={`w-full bg-gradient-to-r from-lime-300 via-yellow-300 to-lime-400 text-black text-lg font-black py-4 rounded-2xl shadow-2xl transform hover:scale-[1.02] active:scale-[0.98] transition-all duration-200 ${
            buttonClicked ? 'opacity-90 pointer-events-none' : ''
          }`}
          style={{
            boxShadow: '0 20px 60px rgba(163, 230, 53, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.5)'
          }}
        >
          {buttonClicked ? "✓ Vous êtes sur la liste d'attente !" : "Rejoindre la liste d'attente"}
        </button>
      </div>
      
      {/* Animations */}
      <style>{`
        @keyframes floatCoin {
          0%, 100% { 
            transform: rotateY(-30deg) rotateX(15deg) translateY(0px);
          }
          50% { 
            transform: rotateY(-30deg) rotateX(15deg) translateY(-12px);
          }
        }
        
        @keyframes floatCash {
          0%, 100% { 
            transform: rotate(-12deg) translateY(0px);
          }
          50% { 
            transform: rotate(-12deg) translateY(-6px);
          }
        }
      `}</style>
    </div>
  );
}
